<script setup lang="ts">
  import type { EnumValues } from '@travelata-libs/utils';
  import { computed } from 'vue';
  import { IconSize, type IconName } from './Icon.types';
  import { ICON_SIZE_IN_PX } from './lib';

  interface IconProps {
    name: EnumValues<typeof IconName>;
    size?: EnumValues<typeof IconSize>;
  }
  const props = withDefaults(defineProps<IconProps>(), {
    size: IconSize.S,
  });

  const symbolId = computed(() => `#icon-${props.name}-${props.size}`);

  const styles = computed(() => ({
    width: ICON_SIZE_IN_PX[props.size],
    height: ICON_SIZE_IN_PX[props.size],
  }));
</script>

<template>
  <svg aria-hidden="true" :style="styles">
    <use :href="symbolId" />
  </svg>
</template>
